import useUser from '../../utils/hooks/useUser';
import SlackDestinationDropdown from '../Slack/SlackDestinationDropdown';
import { isNil } from 'lodash';
import { InstallSlackButton } from '../Slack/InstallSlackButton';
import { MaybeNil } from '../../utils/interfaces';
import { ISlackDestinationFieldsFragment } from '../../utils/apollo/graphqlSchema';
import { IconWrapper, SvgIcon } from '../Icon';
import { FieldLabel, VerticalField } from '../Form';
import React, { ReactElement } from 'react';
import { HorizontalField } from './SchedulerUI';

interface IProps {
  value: MaybeNil<ISlackDestinationFieldsFragment>;
  onChange?: (value: MaybeNil<ISlackDestinationFieldsFragment>) => void;
  label?: ReactElement;
  noMargin?: boolean;
}

export const SlackDestinationRow = ({
  value,
  onChange,
  label,
  noMargin = false,
}: IProps) => {
  const user = useUser();
  if (!isNil(user.slackInstallation)) {
    return (
      <VerticalField noMargin={noMargin}>
        <HorizontalField isEnabled={true}>
          <IconWrapper size={16}>
            <SvgIcon name="slack-logo" />
          </IconWrapper>
          {label ? (
            label
          ) : (
            <FieldLabel>
              Which Slack channel to send notifications to?
            </FieldLabel>
          )}
        </HorizontalField>
        <SlackDestinationDropdown value={value} onChange={onChange} />
      </VerticalField>
    );
  } else if (!isNil(value)) {
    return (
      <VerticalField noMargin={noMargin}>
        <HorizontalField isEnabled={false}>
          <IconWrapper size={16}>
            <SvgIcon name="slack-logo" />
          </IconWrapper>
          {label ? (
            label
          ) : (
            <FieldLabel>
              Which Slack channel to send notifications to?
            </FieldLabel>
          )}
        </HorizontalField>
        <SlackDestinationDropdown value={value} disabled={true} />
        <div>
          <HorizontalField isEnabled={true}>
            <IconWrapper size={16}>
              <SvgIcon name="slack-logo" />
            </IconWrapper>
            <InstallSlackButton customButtonLabel="Connect to Slack to edit" />
          </HorizontalField>
        </div>
      </VerticalField>
    );
  } else {
    return (
      <VerticalField noMargin={noMargin}>
        <HorizontalField isEnabled={true}>
          <IconWrapper size={16}>
            <SvgIcon name="slack-logo" />
          </IconWrapper>
          <InstallSlackButton customButtonLabel="Connect to Slack to enable notifications" />
        </HorizontalField>
      </VerticalField>
    );
  }
};
